import React from 'react'
import PropTypes from 'prop-types'
import Header from 'components/Header'
import Footer from 'components/Footer'
import Aux from 'hoc/Auxiliary'
import SingleCurrencyContainer from 'containers/SingleCurrencyContainer'
import Ad from 'components/Ad'
import MobileApp from 'components/MobileApp'

export const View = ({ mode, ...props }) => {
	const { params } = props.match
	const { currencyParam } = params

	return <Aux>
		<Header title={currencyParam} showCalculator selectedMode={mode} currencyParam={currencyParam} />
		<div className='c-content'>
			<div className='o-wrapper u-padding-vertical-large'>
				<div className='o-layout'>
					<div className='o-layout__item u-1/1 u-margin-bottom'>
						{/*AdSense*/}
						<Ad
							slot='8964911600'
							style={{ display: 'block', height: 120 }}
						/>
					</div>
				</div>
				<div className='u-bg--white u-padding u-border-radius u-box-shadow'>
					<SingleCurrencyContainer currencyParam={currencyParam} mode={mode} {...props} />
				</div>
			</div>
		</div>
		{/*Mobile app section*/}
		<MobileApp mode={mode} />
		<Footer selectedMode={mode} />
	</Aux>
}

View.propTypes = {
	mode: PropTypes.string
}

export default View
